// taken from https://github.com/PacoteJS/pacote/blob/main/packages/react-use-outside/src/index.ts
import React, { useRef, useEffect } from 'react';

type EventType = keyof DocumentEventMap;

export const useOutside = <T extends HTMLDivElement>(
  type: EventType | EventType[],
  handler: EventListener,
): React.RefObject<T> => {
  const inside = useRef<T>(null);

  useEffect(() => {
    const listener = (evt: Event) => {
      if (
        inside.current &&
        evt.target &&
        !inside.current.contains(evt.target as Node)
      ) {
        handler(evt);
      }
    };

    const types = Array<EventType>().concat(type);

    types.forEach((t) => document.addEventListener(t, listener, true));

    return () => {
      types.forEach((t) => document.removeEventListener(t, listener, true));
    };
  }, [type, handler, inside]);

  return inside;
};
